<template>
  <div class="all_customer_style">
    <div class="fixed_search" :style="searchHeight">
      <Form ref="formValidate" class="form_submit_style" :model="formValidate">
        <FormItem v-for="(item,index) in formValidate.searchList" :key="index">
          <Input v-if="item.type=='text' || item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

          <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                           :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

          <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <Select v-if="item.type=='checkbox'" :placeholder="item.customName" class="multiple_search" :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

          <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
        </FormItem>
        <FormItem class="fixed_operation_btn senior_search">
          <el-popover  placement="bottom" width="400" trigger="click" v-if="formValidate.seniorList.length>0" :visible-arrow="visible">
            <div v-for="(item,index) in formValidate.seniorList" :key="index">
              <Input v-if="item.type=='text'|| item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

              <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                               :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

              <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.dictCode" :key="index">{{option.dictValue}}</Option>
              </Select>

              <Select v-if="item.type=='checkbox'" :placeholder="item.customName" class="multiple_style" :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.dictCode" :key="index">{{option.dictValue}}</Option>
              </Select>

              <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

              <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
            </div>
            <el-button slot="reference"><div class="btn_font_search">高级搜索</div></el-button>
          </el-popover>
          <Button type="primary" class="search_btn" style="margin-left: 10px"  @click="initSearch()">查询</Button>
          <Button type="primary" style="margin-left: 10px" class="search_btn reset_btn"  @click="handleReset()">重置</Button>
        </FormItem>
      </Form>
    </div>
    <div class="public_btn" v-if="showPublicBtn">
      <Button class="search_btn template_btn" v-if="roleList['3_10-1']" @click="batchDeleteOperate('系统管理=>已删除客户=>批量删除','3_10-1')">批量删除</Button>
      <Button class="search_btn template_btn" v-if="roleList['3_10-2']" @click="batchReductionCustomer('系统管理=>已删除客户=>批量还原','3_10-2')">批量还原</Button>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  :class="{'tableClass':tableClass}"  @selection-change="getSelectedId">
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width">
                   <template slot="header" slot-scope="scope">
                      <el-tooltip  placement="top">
                        <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;width: 100%;display: block;">{{item.title}}</span>
                        <div slot="content" >
                          <span>{{item.title}}</span>
                        </div>
                      </el-tooltip>
                    </template>
        </el-table-column>
        <el-table-column v-if="contentList.length>0"  fixed="right" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-if="roleList['3_10-3']" @click="singleReductionCustomer('系统管理=>已删除客户=>还原','3_10-3',scope.row.id)" type="text" size="small">还原</el-button>
            <el-button v-if="roleList['3_10-4']" @click="deleteOperate('系统管理=>已删除客户=>删除','3_10-4',scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <deleteTitlePop @closeTitlePop="closeTitlePop" :showTitlePop="showTitlePop" :publicTitle="deleteTitle"></deleteTitlePop>
    <reductionTitlePop @closeReductionTitlePop="closeReductionTitlePop" :showReductionTitlePop="showReductionTitlePop"></reductionTitlePop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublic} from '@/components/js/CustomerPublic.js'
  import deleteTitlePop from '@/components/customerMange/DeleteTitlePop.vue'
  import reductionTitlePop from '@/components/customerMange/ReductionTitlePop.vue'
  export default {
    name: "DeletedCustomer",
    mixins:[publicFunClass,customerPublic],
    components:{
      deleteTitlePop,
      reductionTitlePop
    },
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        formValidate:{"customerState":"2","searchList":[],"seniorList":[],"allColumnInfo":[]},
        showTitlePop: false,
        spinShow: true,
        showReductionTitlePop: false,
        tableClass: true,
        searchParam:[],
        searchHeight:{'height':''},
        visible: true,
        myColor: true,
        wholeColor: false,
        showPublicBtn: false,
        tableHeight:600,
        customerScopeList: [{'id': '0', 'name': '我的客户'}, {'id': '1', 'name': '全部客户'}],
        judgeList: [{'id': '0', 'name': '是'}, {'id': '1', 'name': '否'}],
        judge: '-1',
        checkedAll: false,
        total: 0,
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        deleteUrl:'delCus/doDelete.json',
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        singleCheckedList: [],
        fieldList: [],
        contentList: [],
        checkIds:[],
        tableCount:0,
        currentColName:'',
        journalType:'',
        menuId:'',
        deleteTitle:'批量删除客户',
        editable:false,
        queryParam: null,
      }
    },
    methods:{
      batchReductionCustomer:function(journalType,menuId){
        this.journalType=journalType;
        this.menuId=menuId;
        this.showReductionTitlePop=true;
      },
      closeReductionTitlePop:function(flag,deleteStyle){
        this.showReductionTitlePop=false;
        if (flag) {
          if (deleteStyle=='0'){//选中结果还原
            if (this.checkIds.length==0){
              this.$Modal.info({
                title:'提示',
                content:"请选择要还原的客户"
              });
              return false;
            }
            let param={
              id:this.checkIds.toString(),
              journalType:this.journalType+"选中结果还原",
              menuId:this.menuId
            };
            this.reductionCustomer(param);
          }
          if (deleteStyle=='1'){//搜索结果还原

            if(this.contentList.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可还原的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再还原"
                    });
                    return false;
                }
            delete this.queryParam["pageNum"];
            delete this.queryParam["pageSize"];

            this.$set(this.queryParam, 'type', deleteStyle);
            this.$set(this.queryParam, 'journalType', this.journalType+"搜索结果还原");
            this.$set(this.queryParam, 'menuId', this.menuId);
            this.$set(this.queryParam, 'customerScope', "-1");
            this.$set(this.queryParam, 'customerState', "2");
            // this.getParam(this.formValidate,param);
            this.reductionCustomer(this.queryParam);
          }
        }
      },
      singleReductionCustomer:function(journalType,menuId,id){
        let that=this;
        let param={
          id:id+"",
          journalType:journalType,
          menuId:menuId
        };
        this.$Modal.confirm({
          title: '提示',
          content: "是否还原",
          onOk: () => {
            that.reductionCustomer(param);
          }
        });
      },
      reductionCustomer:function (param) {
        let that=this;
        this.$http.post("delCus/doRestore.json",param) .then(function (res) {
          let result = res.data.flag;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定'
          });
          that.initSearch();
        })
      },
      initSearch:function () {
        this.spinShow=true;
        let selectCount=false;
        let list=this.formValidate.searchList;
        for (let i=0;i<list.length;i++){
          let customValue=list[i].customValue;
          if(customValue){
            selectCount=true;
          }
        }
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null",
          selectCount:selectCount,
          customerScope:"-1",
          customerState:this.formValidate.customerState
        };
        this.getParam(this.formValidate,param);
        this.queryParam = param;
        let url="customer/selectAllCustomer.json";
        this.publicSearch(url,param,1);
      }
    },
    created(){
      this.initPublicBtn(1,3,'3_10-');
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_10' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
          this.handleScroll();
        }
      }
    }
  }
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/customerMange/DeletedCustomer.vue